var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { autoinject, transient } from "aurelia-framework";
import { NotificationClientService, NotificationType } from "../../../../../services/basics/notification-client.service";
import { QueriesClientService } from "../../../../../services/queries/queries-client.services";
import { I18N } from "aurelia-i18n";
import { Router } from "aurelia-router";
import { SourceType } from "../../../../../models/queries/queries.models";
import * as Enumerable from "linq";
import { QueriesEditor } from "../../../../components/queries/queries-editor";
import { ChildComponent } from "../../../../pages/modules/child-component";
import { EventAggregator } from 'aurelia-event-aggregator';
import { DialogServiceConstants } from "../../../../../constants/basics/dialog.constants";
import { DialogClientService } from "../../../../../services/basics/dialog-client.service";
var InstantGameTickets = /** @class */ (function (_super) {
    __extends(InstantGameTickets, _super);
    function InstantGameTickets(notificationService, i18N, queriesService, router, eventAggregator, dialogClient) {
        var _this = _super.call(this, notificationService, i18N) || this;
        _this.queriesService = queriesService;
        _this.router = router;
        _this.eventAggregator = eventAggregator;
        _this.dialogClient = dialogClient;
        return _this;
    }
    InstantGameTickets.prototype.getFilteringQuery = function () {
        if (this.item.brandId && this.item.instantGameId)
            return "/odata/".concat(this.getPath(), "?$filter=instantGameId eq ").concat(this.item.instantGameId, " and brandId eq ").concat(this.item.brandId);
        else if (this.item.instantGameId)
            return "/odata/".concat(this.getPath(), "?$filter=instantGameId eq ").concat(this.item.instantGameId);
        else
            return null;
    };
    InstantGameTickets.prototype.onActivated = function (item) {
        this.reload(item);
    };
    InstantGameTickets.prototype.getPath = function () {
        return "InstantGameTickets";
    };
    InstantGameTickets.prototype.reload = function (item) {
        var _this = this;
        if (this.getFilteringQuery()) {
            this.queriesService.getEntityModels()
                .then(function (models) {
                var e_1, _a;
                var columns = [];
                var selectedModel = Enumerable.from(models).firstOrDefault(function (y) { return y.uri == _this.getPath(); });
                try {
                    // populate columns based on the OData projection properties for the grid
                    for (var _b = __values(selectedModel.projectionProperties), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item_1 = _c.value;
                        var column = QueriesEditor.generateDefaultColumn(item_1, selectedModel);
                        columns.push(column);
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                var oDataUrl = _this.getFilteringQuery();
                _this.itemSource = {
                    source: oDataUrl,
                    sourceType: SourceType.ODataUrl,
                    columns: columns,
                    groupInitialFilters: true
                };
            })
                .catch(function (error) {
                _this.notificationService.show(_this.i18N.tr('error-text') + "!", _this.i18N.tr('error-loading-meta-data-for-query-editor-text'), NotificationType.Error);
            });
        }
    };
    InstantGameTickets.prototype.reloadDataGrid = function () {
        this.dataGrid.reloadData();
    };
    InstantGameTickets.prototype.onItemSelected = function (event) {
        var item = event.detail.item;
        //this.eventAggregator.publish('change-step-tab', { id: item.id, step: StepEnum.InstantGameTicketLines });
        require("./instant-game-ticket-lines");
        // pass data to ticket sales list dialog
        var dialogNavigationInfo = {
            transactionId: item.transactionId,
            brandId: item.brandId,
            brandName: item.brandName,
            operatorId: item.operatorId,
            operatorName: item.operatorName,
            playerId: item.playerId,
            numberOfTries: item.numberOfTries,
            instantGameId: item.instantGameId,
            instantGameName: item.instantGameName
        };
        this.dialogClient.show(DialogServiceConstants.URLs.InstantGameTicketSaleListDialog, { dialogNavigationInfo: dialogNavigationInfo });
    };
    InstantGameTickets = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [NotificationClientService,
            I18N,
            QueriesClientService,
            Router,
            EventAggregator,
            DialogClientService])
    ], InstantGameTickets);
    return InstantGameTickets;
}(ChildComponent));
export { InstantGameTickets };
